<template>
	<div class="document-list-item" @click="$emit('click')">
		<div class="document-info">
			<p class="company">{{ company }}</p>
			<p class="file-name">{{ fileName }}</p>
			<p class="date">Added {{ date }}</p>
			<p class="document-type">{{ documentType }}</p>
		</div>
		<div class="arrow-icon">
			<img class="arrow" src="../../assets/arrow-right.png">
		</div>
	</div>
</template>

<script>
export default {
	name: 'DocumentListItem',
	props: {
		company: {
			type: String,
			default: ''
		},
		fileName: {
			type: String,
			default: ''
		},
		date: {
			type: String,
			default: ''
		},
		documentType: {
			type: String,
			default: ''
		}
	},
	emits: ['click']
}
</script>

<style scoped>
.document-list-item {
	background: white;
	border-radius: 8px;
	padding: 12px 16px;
	display: flex;
	align-items: center;
	gap: 8px;
}

.document-info {
	flex: 1;
	display: flex;
	flex-direction: column;
	gap: 8px;
	min-width: 0;
}

.document-info p {
	margin: 0;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

.company {
	font-size: 13px;
	font-weight: bold;
	line-height: 1;
}

.file-name {
	font-size: 12px;
	line-height: 1;
}

.date {
	font-size: 12px;
	line-height: 1;
	opacity: 0.5;
}

.document-type {
	font-size: 11px;
	font-weight: bold;
	line-height: 1;
}

.arrow {
	width: 16px;
}
</style>
